import { request } from 'graphql-request';
import { API_URL, APP_DOMAIN } from 'appenv';

const fetchParticipantsByRoleQuery = `
  query fetchParticipantsByRole(
    $domain: String!,
    $afterCursor: String,
    $vexpoRole: String,
    $limit: Int,
  ) {
    eventByDomain(domain: $domain) {
      attendeesByCustomFieldVexpoRole(
        vexpoRole: $vexpoRole,
        first: $limit,
        after: $afterCursor
      ) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          cursor
          node {
            name
            customAttendeeFields
            uuid
            vexpoChatTag
            vexpoChatUserDescription
            enrichment
          }
        }
      }
    }
  }
`;

function fetchParticipantsByRole(vexpoRole, afterCursor, limit) {
  return request(API_URL, fetchParticipantsByRoleQuery, {
    domain: APP_DOMAIN,
    afterCursor,
    vexpoRole,
    limit,
  }).then((result) => {
    const { eventByDomain: { attendeesByCustomFieldVexpoRole } } = result;
    return attendeesByCustomFieldVexpoRole;
  });
}

export default fetchParticipantsByRole;
